import { Component, inject, Input, OnInit } from '@angular/core';
import { ImageUrls } from '@app/shared/constants/image-urls-const';

@Component({
    selector: 'app-no-filter-data-found',
    imports: [],
    templateUrl: './no-filter-data-found.component.html',
    styleUrl: './no-filter-data-found.component.css'
})
export class NoFilterDataFoundComponent implements OnInit {
  imageConst = inject(ImageUrls);
  @Input() pageName: string = '';
  pageData: any = {};

  ngOnInit(): void {
    this.getPageData();
  }

  getPageData() {
    if (this.pageName === 'subject-report')
      this.pageData = { message: 'No reports available', description: 'Get started by uploading a report' }
    else
      this.pageData = { message: 'No records available', description: 'There are no records to display for the selected filter(s)' }
  }
}
